import fs from 'fs'
import { select } from '@inquirer/prompts'
import get from 'lodash/get'
import { CustomComponentLibraryWrappedClient } from '../../customComponentLibraryWrappedClient'

async function whichLibraryPrompt(client: CustomComponentLibraryWrappedClient): Promise<string | null> {
  const libraries = await client.customComponentLibrariesGet()
  if (libraries.data.length === 0) {
    throw new Error('No custom component libraries available to sync')
  }
  const selection = await select({
    message: 'Which library would you like to sync',
    choices: libraries.data.map((library) => {
      return { name: library.name, value: library.id }
    }),
  })

  return selection
}

export async function getLibraryToSync(client: CustomComponentLibraryWrappedClient) {
  let libraryUuid: string | null = null

  if (fs.existsSync('package.json')) {
    const packageJson = JSON.parse(fs.readFileSync('package.json').toString()) as Record<string, unknown>
    const maybeLibraryName = get(packageJson, 'retoolCustomComponentLibraryConfig.name')
    if (typeof maybeLibraryName === 'string') {
      const libraries = await client.customComponentLibrariesGet()
      const matchingLibrary = libraries.data.find((library) => library.name === maybeLibraryName)
      if (matchingLibrary) {
        libraryUuid = matchingLibrary.id
      }
    }
  }

  while (!libraryUuid) {
    libraryUuid = await whichLibraryPrompt(client)
  }

  return libraryUuid
}
